// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"main-template_wrapper__QL0vo"};